import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-agriculture',
  imports: [PillarPagesTemp],
  templateUrl: './agriculture.html',
  styleUrl: './agriculture.scss',
})
export class Agriculture {

}
